import React from 'react'

import { formatNumber, NumberFormats } from '@/shared/tools/locale'

export function BasicPriceField({
	value,
	ref,
}: {
	value: number | null | undefined
	ref?: React.Ref<HTMLDivElement>
}) {
	if (value === null || value === undefined) {
		return (
			<div ref={ref} className='cell-data-number'>
				-
			</div>
		)
	}

	return (
		<div ref={ref} className='cell-data-number'>
			{formatNumber(value, NumberFormats.Fixed)}
		</div>
	)
}
